module.exports = __webpack_public_path__ + "static/media/logo-white.1e04ac8f.png";